import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import inchatActions from 'redux/inchat/actions'
import './styles.scss'
import Message from 'components/InChatView/ChatMessages/Message'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'
import { toastMessage } from 'utils/messages'
import { apiInchat } from 'api'
import LocalEditor from './LocalEditor'

const Threads = () => {
  const dispatch = useDispatch()
  const [threads, setThreads] = useState([])
  const inchat = useSelector((state) => state.inchat)
  const operator = useSelector((state) => state.user)

  useEffect(() => {
    getThreads()
  }, [])

  const getThreads = async () => {
    apiInchat.getThreadsByMessage()
      .then(({ data: { data } }) => {
        const _threads = data.map((thread) => {
          const parentId = getParentId(thread)
          return {
            ...thread,
            parentId: parentId
          }
        })
        setThreads(_threads)
      })
      .catch(error => console.error(error))
      .finally()
  }

  const getHeader = (thread) => {
    if (thread.type === 'direct') {
      const user = thread.users.find(user => user._id !== operator.id)
      const nameToShow = user.name || user.lastname ? `${user.name} ${user.lastname}` : user.email
      return (
        <div className='group-header direct'>
          <span className='title'>{nameToShow}</span>
        </div>
      )
    }
    if (thread.type === 'group') {
      const participants = thread.users.map(user => user.name || user.lastname ? `${user.name} ${user.lastname}` : user.email)
      return (
        <div className='group-header'>
          <span className='title'>{participants.join(' ')}</span>
        </div>
      )
    }
    if (thread.type === 'channel') {
      const channelName = thread.name
      const participants = thread.users.map( user => user.name || user.lastname ? `${user.name} ${user.lastname}` : user.email)
      return (
        <div className='group-header'>
          <span className='title'>{`#${channelName}`}</span>
          <span className='legend'>{participants.join(' ')}</span>
        </div>
      )
    }
    return null
  }

  const getParentId = (thread) => {
    const parentMessage = thread?.messages.find(message => message.hasThread)

    if (!parentMessage) return null
    return !Array.isArray(parentMessage) ? parentMessage._id : parentMessage[0]._id || null
  }

  const sendMessage = async (conversationId, newConversationId) => {

    dispatch(inchatActions.sendMessage(conversationId, true, null, newConversationId))
      .then(() => {
        getThreads()
      })
      .catch(() => toastMessage(lang('inchat_error_message_sent'), 'error'))
  }

  return (
    <div className='inchat-threads'>
      <div className='header'>
        <span className='title-threads'>{lang('inchat_threads')}</span>
      </div>
      <div className='content'>
        { (!inchat.thread || inchat.thread === 0) &&
          <div className='no-threads'>
            <img src={getStaticImage('/icons/orange-brand/icon-empty.svg')} alt='no-threads' />
            <span>{lang('inchat_no_threads')}</span>
          </div>
        }
        {
          threads.map((thread, index) => {
            return (
              <div key={`id-${index}`} className='group-wrapper'>
                {getHeader(thread)}
                <LocalEditor
                  thread={thread}
                  composer={inchat.conversations[`${thread._id}_${thread.parentId}`]?.composer || {}}
                  channel={'inChat'}
                  parentId={thread.parentId}
                  conversationId={thread._id}
                  sendMessageAlt={() => sendMessage(thread._id, `${thread._id}_${thread.parentId}`)}
                />
                <div className='group-inner'>
                  <div className='messages'>
                    {thread?.messages?.map((message, index2) => {
                      return (
                        <Message
                          key={index2}
                          message={message}
                          operatorId={operator.id}
                          showReactions={false}
                          showAvatar={message.userId !== operator.id}
                          showOptions={false}
                        />
                      )
                    })}
                  </div>
                </div>
              </div>
            )}
          )
        }
      </div>
    </div>
  )
}

export default Threads
